import { GetStaticProps } from 'next'

import query from './queries'

import initApollo, { API } from 'src/api'

export type Props = API.Editor

export const getStaticProps: GetStaticProps<Props> = async () => {
  const client = initApollo({})

  const { data } = await client.query<API.Editor>({
    query,
  })

  return {
    props: data,
  }
}
